import React from 'react';
import SubNavbar from '../components/SubNavbar';

const Work = () => {
  return (
    <div className="white-page">
      <SubNavbar />
      <div className="work-content">
        <div className="work-timeline">
          <div className="work-entry">
            <h2 className="work-role">Education</h2>
            <p className="work-details">High Performance Computing, University of Edinburgh, In Progress</p>
            <p className="work-details">BSc, Computer Science, University of Oklahoma, 2024</p>
          </div>

          <hr className="work-section-divider" />
          <div className="work-header-with-resume">
            <h2 className="work-role">Experience<a href="/HadiFawadResume9-4.pdf" target="_blank" rel="noopener noreferrer" className="work-resume-inline">→ View my complete resume</a></h2>
          </div>

          <div className="work-entry">
            <h2 className="work-role">Human Union Data (YC W25) <span className="work-period">(Research Collaborator, September 2025 - present)</span></h2>
            <p className="work-details">Conducting research on vulnerability detection benchmarks for LLMs by analyzing CVE databases and open-source repositories to identify exploitable security flaws in government and infrastructure software. <em>I've just started on this effort so expect updates soon!</em></p>
          </div>

          <div className="work-entry">
            <h2 className="work-role">Supervised Program for Alignment Research <span className="work-period">(Research Fellow, September 2025 - present)</span></h2>
            <p className="work-details">I'm part of a selective research cohort focused on AI alignment and safety, where I contribute to research in AI systems that can be safely deployed in critical applications.</p>
          </div>

          <div className="work-entry">
            <h2 className="work-role">SAIC <span className="work-period">(Machine Learning Engineer, June 2024 - present)</span></h2>
            <p className="work-details">Part of the leading implementation of agentic AI systems within a Fortune 500 company, architecting internal Agentic AI Systems using LangGraph and contributing to collision prediction systems. Worked across various contracts requiring rapid expertise development and end-to-end solution delivery from 0 to 1.</p>
          </div>
          
          <div className="work-entry">
            <h2 className="work-role">Stanford University <span className="work-period">(Research Assistant, September 2023 - April 2024)</span></h2>
            <p className="work-details">I collaborated with Cardiothoracic laboratories on large-scale data analysis projects, processing massive cellular datasets exceeding 1.5TB using statistical techniques from linear regression models to traditional methods. While the analysis wasn't cutting-edge, I learned an incredible amount about various heart tissues and cellular structures, and how to apply ML to situations outside of just tech through this interdisciplinary work.</p>
          </div>
          
          <div className="work-entry">
            <h2 className="work-role">Stanford Center for Human Rights and International Justice <span className="work-period">(Research Fellow, 2023-2024)</span></h2>
            <p className="work-details">I was part of a research cohort focused on collaborating with public benefit organizations like the UNHCR to develop ethical AI applications that serve humanitarian and social good initiatives.</p>
          </div>
          
          <div className="work-entry">
            <h2 className="work-role">Spectrum <span className="work-period">(Software Engineer Intern, May 2023 - August 2023)</span></h2>
            <p className="work-details">Transformed a manual environment update process into an automated CI/CD pipeline using Docker and Kubernetes, reducing deployment time from 10+ hours to 5 minutes for a team of 200+ engineers.</p>
          </div>

          {/* <div className="work-mission-link">
            <a href="/writings/blog-post-1" className="work-link">
              Too research-oriented? Or too builder-oriented? Read my work justification →
            </a>
          </div> */}

          <hr className="work-section-divider" />

          <div className="work-entry">
            <h2 className="work-role">Projects & Publications</h2>
            <p className="work-details">
              <a href="https://journals.ametsoc.org/view/journals/bams/106/6/BAMS-D-24-0147.1.xml" target="_blank" rel="noopener noreferrer" className="work-link">
                The Observed Availability of Data and Code in Earth Science and Artificial Intelligence
              </a> (BAMS, 2025)
            </p>
            <p className="work-details">
              <a href="https://github.com/Hadi-Fawad/ParallelProgrammingProject/tree/main" target="_blank" rel="noopener noreferrer" className="work-link">
                Memory & Loop Optimization for High-Performance Computing
              </a>
            </p>
            <p className="work-details">
              <a href="https://devpost.com/software/hackanalyzer" target="_blank" rel="noopener noreferrer" className="work-link">
                HackAnalyzer
              </a> (2nd Place, HackHarvard)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
